<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('imports.fecha_header')}}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.from')}}
                        <el-form-item prop="fechaDesde">
                          <el-date-picker
                            class="bg-white dark:bg-darkblue-900"
                            v-model="form.fechaDesde.value"
                            type="date"
                            :picker-options="dateRangeOptions"
                            :format="datePattern" value-format="yyyy-MM-dd" placeholder=""
                            >
                          </el-date-picker>
                        </el-form-item>
                      </label>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.to')}}
                        <el-form-item prop="fechaHasta">
                          <el-date-picker
                            class="bg-white dark:bg-darkblue-900"
                            v-model="form.fechaHasta.value"
                            type="date"
                            :picker-options="dateRangeOptions"
                            :format="datePattern" value-format="yyyy-MM-dd" placeholder=""
                            >
                          </el-date-picker>
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>

            <div v-if="(role === 7 || role === 8 || role === 3)">
              <div v-if="role === 3">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.entity_name')}}
                <el-form-item prop="distribuidor">
                  <base-el-select :options="distribuidores" v-model="form.distribuidor.value"
                    :option-listeners="{ select: handleSelectDistribuidor }" class="w-full" clearable filterable
                    value-key="idDistribuidor" :loading="loadingDistribuidores" />
                </el-form-item>
                </label>
              </div>

              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.entity_name')}}
                <el-form-item prop="empresa">
                  <base-el-select class="w-full" :options="clientes" v-model="form.empresa.value" clearable filterable
                    value-key="idCliente" :loading="loadingClientes" />
                </el-form-item>
              </label>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('imports.type')}}
                <el-form-item prop="tipoImportacion">
                  <el-select class="w-full" v-model="form.tipoImportacion.value" clearable filterable>
                    <el-option
                      v-for="item in tiposImportacion"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      @select="handleSelectTipoImportacion">
                    </el-option>
                  </el-select>
                </el-form-item>
              </label>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('imports.status')}}
                <el-form-item prop="tipoImportacionEstado">
                  <el-select class="w-full" v-model="form.tipoImportacionEstado.value" clearable filterable>
                    <el-option
                      v-for="item in tiposImportacionEstado"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      @select="handleSelectTipoImportacionEstado">
                    </el-option>
                  </el-select>
                </el-form-item>
              </label>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('users.entity_name')}}
                <el-form-item prop="usuario">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.usuario.value"
                    maxlength="50"
                  />
                </el-form-item>
              </label>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loadingDistribuidores: false,
      loadingClientes: false,
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'imports',
      isOpen: this.panelOpen,
      form: {
        fechaDesde: { label: i18n.t('imports.filter_fecha_desde'), value: '' },
        fechaHasta: { label: i18n.t('imports.filter_fecha_hasta'), value: '' },
        tipoImportacion: { label: i18n.t('imports.type'), value: '' },
        tipoImportacionEstado: { label: i18n.t('imports.status'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        usuario: { label: i18n.t('configurations.username'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      distribuidores: [],
      clientes: [],
    }
  },

  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: { idCliente: x.idCliente, Nombre: x.Nombre } }))
      this.loadingClientes = false

      if (this.role === 3) {
        this.loadingDistribuidores = true
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataDistributors))
        }
        this.distribuidores = dataDistributors.Distribuidores.map(x => ({ label: x.Nombre, key: x.IdDistribuidor, value: { idDistribuidor: x.IdDistribuidor, Nombre: x.Nombre } }))
        this.loadingDistribuidores = false
      }
    }
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposImportacion () {
      return this.$store.getters['config/TIPOS_IMPORTACION']
    },
    tiposImportacionEstado () {
      return this.$store.getters['config/TIPOS_IMPORTACION_ESTADO']
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
        this.form.fechaDesde.value = _temp.fechaDesde !== undefined && _temp.fechaDesde.value !== '' ? _temp.fechaDesde.value : ''
        this.form.fechaHasta.value = _temp.fechaHasta !== undefined && _temp.fechaHasta.value !== '' ? _temp.fechaHasta.value : ''
        this.form.tipoImportacion.value = _temp.tipoImportacion !== undefined && _temp.tipoImportacion.value !== '' ? _temp.tipoImportacion.value : ''
        this.form.tipoImportacionEstado.value = _temp.tipoImportacionEstado !== undefined && _temp.tipoImportacionEstado.value !== '' ? _temp.tipoImportacionEstado.value : ''
        this.form.usuario.value = _temp.usuario !== undefined && _temp.usuario.value !== '' ? _temp.usuario.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        fechaDesde: { label: i18n.t('imports.filter_fecha_desde'), value: '' },
        fechaHasta: { label: i18n.t('imports.filter_fecha_hasta'), value: '' },
        tipoImportacion: { label: i18n.t('imports.type'), value: '' },
        tipoImportacionEstado: { label: i18n.t('imports.status'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        usuario: { label: i18n.t('configurations.username'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
    handleSelectTipoImportacion: function (item) {
      this.form.tipoImportacion.value = item.id
    },
    handleSelectTipoImportacionEstado: function (item) {
      this.form.tipoImportacionEstado.value = item.id
    },
  }
}
</script>
